import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import loginImage from '../../../assets/images/login-image.jpg'
import Image from '../../atoms/Image/Image'
import LoginForm from '../../molecules/Form/LoginForm'
import {Link} from 'react-router'
const Login = () => {
    
    return (
        <>
            <section className="login-form section-padding">
                <Container>
                    <Row className='g-0 align-items-center justify-content-center'>
                        <Col className='col-12 col-md-10 p-0 login-form--item'>
                            <Row className='g-0 align-items-center justify-content-center'>
                                <Col className='col-12 col-lg-6'>
                                    <div className='login-form--item-left'>
                                        <h1 className='h1'>Welcome Back To Europ Cars</h1>
                                        <p className='mb-0'>Hello there, sign in to continue.</p>
                                        <LoginForm />
                                        
                                    </div>
                                </Col>
                                <Col className='col-12 col-lg-6'>
                                    <figure className="mb-0 login-form--item--image">
                                        <Image src={loginImage} alt="" height="1000" width="900" />
                                    </figure>
                                </Col>
                            </Row>
                        </Col> 
                    </Row>
                    <Row className='justify-content-center mt-5'>
                        <Col className='col-12 col-md-10 text-center '>
                            <h5 className='mb-0 h5 '>Don't have an account? <Link to="/register">Create one now!</Link> </h5>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default Login
